<!-- Chart Templates Sidebar -->
<div class="add-chart-container" *ngIf="showTemplatesOnly && !selectedChartType">
  <div class="panel-header">
    <h3>Add Charts</h3>
    <button class="btn-close" (click)="onClose()">×</button>
  </div>

  <div class="search-container">
    <div class="search-input-wrapper">
      <img src="assets/icons/search.svg" alt="search" class="search-icon" />
      <input
        type="text"
        class="search-input"
        placeholder="Search"
        [(ngModel)]="searchQuery"
        (input)="onSearch()"
      />
    </div>
  </div>

  <div class="chart-types-container" *ngIf="!isLoading && getCategoryKeys().length > 0">
    <div class="chart-category" *ngFor="let category of getCategoryKeys()">
      <div class="category-header">
        <span class="category-title">{{ category }}</span>
        <span class="category-icon">▼</span>
      </div>
      <div class="chart-list">
        <div class="chart-item" [class.unavailable]="!chartType.availability_status" *ngFor="let chartType of chartCategories[category]; let i = index" (click)="chartType.availability_status && onAddChartTemplate(chartType)">
          <div class="chart-preview">
            <img [src]="chartType.icon || 'assets/icons/bar_chart_icon.svg'" alt="{{ chartType.name }}" />
          </div>
          <div class="chart-info">
            <div class="chart-title-row">
              <h4>{{ chartType.name }}</h4>
              <span class="available-tag" *ngIf="chartType.availability_status">Available</span>
              <span class="unavailable-tag" *ngIf="chartType.availability_status === false">Coming soon</span>
            </div>
            <p>{{ chartType.description || 'Use this chart when you need to visualise two data points.' }}</p>
            <button class="btn-add-chart" (click)="onAddChartTemplate(chartType); $event.stopPropagation()" *ngIf="chartType.availability_status">
              Add Chart
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="loading" *ngIf="isLoading">
    <div class="loading-spinner"></div>
    <p>Loading chart types...</p>
  </div>

  <div class="error-message" *ngIf="!isLoading && getCategoryKeys().length === 0 && chartTypes.length === 0">
    <p>No chart types available. Please check your API connection.</p>
  </div>
</div>

<!-- Chart Configuration Form -->
<div class="chart-form-container" *ngIf="!showTemplatesOnly || selectedChartType">

  <!-- Saving overlay with animation -->
  <div class="chart-save-overlay" *ngIf="isSavingChart">
    <div class="chart-save-overlay-content">
      <div class="chart-save-spinner"></div>
      <p class="chart-save-message">{{ currentChartId ? 'Updating chart...' : 'Generating chart...' }}</p>
    </div>
  </div>

  <div class="form-content" [class.form-content-saving]="isSavingChart">
    <!-- Required fields -->
    <section class="form-section form-section--required">
      <!-- <h4 class="form-section__title">Required</h4> -->
      <div class="form-section__body">
    <div class="form-group">
      <label>Chart Type <span class="required">*</span></label>
      <form-select-dropdown
        [contentList]="chartTypeOptions"
        [selectedValue]="selectedChartTypeOption"
        [placeholder]="'Select Chart Type'"
        [disabled]="isEditMode"
        [dropdownId]="'chart-type-dropdown'"
        (onItemSelect)="onChartTypeDropdownSelect($event)"
      ></form-select-dropdown>
      <div class="form-hint" *ngIf="!selectedChartType">
        Please select a chart type to configure
      </div>
      <div class="form-hint" *ngIf="selectedChartType && !isEditMode">
        {{ selectedChartType.description }}
      </div>
      <div class="form-hint" *ngIf="isEditMode && selectedChartType">
        {{ selectedChartType.description }}
        <br><small style="color: #666; font-style: italic;">Chart type cannot be changed when editing an existing chart</small>
      </div>
    </div>

    <!-- Chart Title - Required -->
    <div class="form-group">
      <label>Chart Title <span class="required">*</span></label>
      <input
        type="text"
        class="form-input"
        placeholder="Enter chart title..."
        [(ngModel)]="chartTitle"
        required
      />
      <div class="form-hint">A suitable title for your chart</div>
    </div>

    <!-- Metric Type - Required -->
    <div class="form-group">
      <label>Metric Type <span class="required">*</span></label>
      <div *ngIf="!selectedChartType" class="form-hint">
        Please select a chart type first
      </div>
      <div *ngIf="selectedChartType && isLoading" class="form-hint">
        Loading metrics...
      </div>
      <form-select-dropdown
        *ngIf="selectedChartType && !isLoading"
        [contentList]="metricOptions"
        [selectedValue]="selectedMetricOption"
        [placeholder]="'Select Metric'"
        [disabled]="isLoading"
        [dropdownId]="'metric-type-dropdown'"
        (onItemSelect)="onMetricDropdownSelect($event)"
      ></form-select-dropdown>
      <div class="form-hint" *ngIf="selectedChartType && !isLoading && metrics.length === 0">
        No metrics available for this chart type. Please check API connection.
      </div>
    </div>

    <!-- Date Range - Required -->
    <div class="form-group">
      <label>Date Range <span class="required">*</span></label>
      <div class="date-range-type-group">
        <form-select-dropdown
          [contentList]="dateRangeOptions"
          [selectedValue]="selectedDateRangeOption"
          [placeholder]="'Select Date Range'"
          [disabled]="false"
          [dropdownId]="'date-range-dropdown'"
          (onItemSelect)="onDateRangeDropdownSelect($event)"
        ></form-select-dropdown>
      </div>
      <!-- Custom Date Range -->
      <div class="date-range-group" *ngIf="!dateRangeType || dateRangeType === 'custom_range'">
        <input
          type="date"
          class="form-input"
          [(ngModel)]="startDate"
          [required]="!dateRangeType || dateRangeType === 'custom_range'"
          [min]="minDate"
          (ngModelChange)="onStartDateChange($event)"
        />
        <span>to</span>
        <input
          type="date"
          class="form-input"
          [(ngModel)]="endDate"
          [required]="!dateRangeType || dateRangeType === 'custom_range'"
          [max]="maxEndDate"
          [min]="startDate"
          (ngModelChange)="onEndDateChange($event)"
        />
      </div>
      <div class="form-hint" *ngIf="(!dateRangeType || dateRangeType === 'custom_range') && futureRangeHint">
        {{ futureRangeHint }}
      </div>
      <div class="form-hint" *ngIf="!dateRangeType || dateRangeType === 'custom_range'">
        Custom range can span up to 90 days.
      </div>
      <!-- Last N Days -->
      <div class="last-n-days-group" *ngIf="dateRangeType === 'last_n_days'">
        <input
          type="number"
          class="form-input"
          [(ngModel)]="lastNDays"
          [required]="dateRangeType === 'last_n_days'"
          min="1"
          placeholder="Enter number of days"
        />
        <span class="form-hint">Enter the number of days to look back</span>
      </div>
      <!-- Dynamic Date Range Info -->
      <div class="form-hint" *ngIf="dateRangeType && dateRangeType !== 'custom_range' && dateRangeType !== 'last_n_days'">
        Using {{ getDateRangeDisplayLabel(dateRangeType) }} (automatically calculated)
      </div>
    </div>

    <!-- Time Zone (same as Insights dashboard; default EST) -->
    <div class="form-group">
      <label>Time Zone</label>
      <form-select-dropdown
        [contentList]="timezoneOptions"
        [selectedValue]="selectedTimezoneOption"
        [placeholder]="'Select Time Zone'"
        [dropdownId]="'timezone-dropdown'"
        (onItemSelect)="onTimezoneDropdownSelect($event)"
      ></form-select-dropdown>
      <div class="form-hint">Time zone for chart data (default: EST)</div>
    </div>

    <!-- Dimension -->
    <div class="form-group" *ngIf="shouldShowDimensionField()">
      <label>
        Dimension
        <span *ngIf="isDimensionRequired()" class="required">*</span>
        <span *ngIf="!isDimensionRequired()" class="optional">(Optional)</span>
      </label>
      <form-select-dropdown
        [contentList]="dimensionOptions"
        [selectedValue]="selectedDimensionOption"
        [placeholder]="isLoadingDimensions ? 'Loading dimensions...' : 'Select Dimension'"
        [disabled]="!selectedChartType || isLoadingDimensions"
        [dropdownId]="'dimension-dropdown'"
        (onItemSelect)="onDimensionDropdownSelect($event)"
      ></form-select-dropdown>
      <div class="form-hint" *ngIf="selectedChartTypeRaw?.required_dimensions">
        This chart requires {{ selectedChartTypeRaw.required_dimensions }} dimension(s)
      </div>
      <div class="form-hint" *ngIf="!selectedChartTypeRaw?.required_dimensions && selectedChartType">
        Dimension is optional but recommended for better chart visualization
      </div>
    </div>

    <!-- Secondary Dimension - Optional or Required based on chart type -->
    <div class="form-group" *ngIf="shouldShowSecondaryDimensionField()">
      <label>
        Secondary Dimension
        <span *ngIf="isSecondaryDimensionRequired()" class="required">*</span>
        <span *ngIf="!isSecondaryDimensionRequired()" class="optional">(Optional)</span>
      </label>
      <form-select-dropdown
        [contentList]="getSecondaryDimensionOptions()"
        [selectedValue]="selectedSecondaryDimensionOption"
        [placeholder]="isLoadingDimensions ? 'Loading...' : 'None'"
        [disabled]="!selectedChartType || (!selectedDimension && isSecondaryDimensionRequired()) || isLoadingDimensions"
        [dropdownId]="'secondary-dimension-dropdown'"
        (onItemSelect)="onSecondaryDimensionDropdownSelect($event)"
      ></form-select-dropdown>
      <div class="form-hint" *ngIf="isSecondaryDimensionRequired()">
        This chart type requires a secondary dimension
      </div>
      <div class="form-hint" *ngIf="!selectedDimension && isSecondaryDimensionRequired()">
        Please select a primary dimension first
      </div>
    </div>
      </div>
    </section>

    <!-- Optional fields (collapsible) -->
    <section class="form-section form-section--optional" [class.form-section--collapsed]="!optionalSectionExpanded">
      <button type="button" class="form-section__title form-section__title--clickable" (click)="toggleOptionalSection()" [attr.aria-expanded]="optionalSectionExpanded">
        <span>Optional</span>
        <span class="form-section__chevron" [class.form-section__chevron--expanded]="optionalSectionExpanded">▼</span>
      </button>
      <!-- Keep mounted when collapsed so ViewChild + filter state survive edit/save -->
      <div class="form-section__body" [hidden]="!optionalSectionExpanded">
    <!-- Filters (Insights-style: button opens panel on top) -->
    <div class="form-group">
      <label class="form-section__subsection-label">Filters</label>
      <chart-filter-section-wrapper
        [buttonMode]="true"
        [initialFilterConditions]="initialFilterConditions">
      </chart-filter-section-wrapper>
    </div>

    <div class="form-group form-section-card" *ngIf="getValidCriteriaOptions().length > 0">
      <label>Criteria</label>
      <div class="criteria-group" *ngFor="let option of getValidCriteriaOptions()">
        <label class="criteria-label">{{ option.label || option.field }}</label>
        <input
          *ngIf="option.type === 'number'"
          [type]="option.field === 'top_n' ? 'text' : 'number'"
          class="form-input"
          [(ngModel)]="criteria[option.field]"
          [min]="option.min !== undefined ? option.min : 1"
          [attr.max]="option.max !== undefined ? option.max : null"
          [attr.pattern]="option.field === 'top_n' ? '[1-9][0-9]*' : null"
          [attr.title]="option.field === 'top_n' ? 'Please enter a positive integer (1, 2, 3, ...)' : null"
          [attr.data-field]="option.field"
          (keypress)="option.field === 'top_n' ? onTopNKeyPress($event) : true"
          (input)="option.field === 'top_n' ? onTopNInput($event) : null"
        />
        <input
          *ngIf="option.type === 'string'"
          type="text"
          class="form-input"
          [(ngModel)]="criteria[option.field]"
        />
        <select
          *ngIf="option.type === 'select'"
          class="form-select"
          [(ngModel)]="criteria[option.field]"
        >
          <option *ngFor="let opt of option.options" [value]="opt.value">
            {{ opt.label || opt.value }}
          </option>
        </select>
        <select
          *ngIf="option.type === 'boolean'"
          class="form-select"
          [(ngModel)]="criteria[option.field]"
        >
          <option [value]="true">True</option>
          <option [value]="false">False</option>
        </select>
      </div>
    </div>

    <!-- Chart-Specific Criteria Options -->
    <div class="form-group form-section-card" *ngIf="hasChartSpecificOptions()">
      <label>Chart-Specific Options</label>

      <!-- Pie/Donut Chart Options -->
      <div *ngIf="isPieOrDonutChart()" class="chart-specific-options">
        <div class="criteria-group">
          <label class="criteria-label">
            <input type="checkbox" [(ngModel)]="criteria.show_percentage" [checked]="criteria.show_percentage !== false" />
            Show Labels
          </label>
        </div>
        <div class="criteria-group">
          <label class="criteria-label">Minimum Slice Percentage</label>
          <input
            type="number"
            class="form-input"
            [(ngModel)]="criteria.min_slice_percentage"
            min="0"
            max="10"
            step="0.1"
            required
            placeholder="1"
            (input)="onMinSlicePercentageInput($event)"
            (blur)="onMinSlicePercentageBlur()"
          />
          <small class="form-hint">Default 1; allowed range 0 to 10</small>
        </div>
        <div class="criteria-group" *ngIf="isDonutChart()">
          <label class="criteria-label">Inner Size (Donut)</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="criteria.inner_size"
            placeholder="50%"
          />
          <small class="form-hint">Inner size as percentage (e.g., "50%")</small>
        </div>
      </div>

      <!-- Bubble/Scatter Chart Options -->
      <div *ngIf="isBubbleOrScatterChart()" class="chart-specific-options">
        <div class="criteria-group">
          <label class="criteria-label">Bubble Size Mode</label>
          <select class="form-select" [(ngModel)]="criteria.bubble_size">
            <option value="fixed">Fixed</option>
            <option value="proportional">Proportional</option>
          </select>
        </div>
        <div class="criteria-group">
          <label class="criteria-label">Min Bubble Size</label>
          <input
            type="number"
            class="form-input"
            [(ngModel)]="criteria.min_bubble_size"
            min="1"
          />
        </div>
        <div class="criteria-group">
          <label class="criteria-label">Max Bubble Size</label>
          <input
            type="number"
            class="form-input"
            [(ngModel)]="criteria.max_bubble_size"
            min="1"
          />
        </div>
      </div>

      <!-- Treemap Options -->
      <div *ngIf="isTreemapChart()" class="chart-specific-options">
        <div class="criteria-group">
          <label class="criteria-label">Layout Algorithm</label>
          <select class="form-select" [(ngModel)]="criteria.layout_algorithm">
            <option value="sliceAndDice">Slice and Dice</option>
            <option value="stripes">Stripes</option>
            <option value="squarified">Squarified</option>
            <option value="strip">Strip</option>
          </select>
        </div>
      </div>

      <!-- Sankey Options -->
      <div *ngIf="isSankeyChart()" class="chart-specific-options">
        <div class="criteria-group">
          <label class="criteria-label">Min Link Width</label>
          <input
            type="number"
            class="form-input"
            [(ngModel)]="criteria.min_link_width"
            min="1"
          />
        </div>
        <div class="criteria-group">
          <label class="criteria-label">Node Padding</label>
          <input
            type="number"
            class="form-input"
            [(ngModel)]="criteria.node_padding"
            min="0"
          />
        </div>
      </div>

      <!-- Waterfall Options -->
      <div *ngIf="isWaterfallChart()" class="chart-specific-options">
        <div class="criteria-group">
          <label class="criteria-label">
            <input type="checkbox" [(ngModel)]="criteria.show_connectors" [checked]="criteria.show_connectors !== false" />
            Show Connectors
          </label>
        </div>
      </div>

      <!-- Polar/Radar Options -->
      <div *ngIf="isPolarOrRadarChart()" class="chart-specific-options">
        <div class="criteria-group">
          <label class="criteria-label">Start Angle (degrees)</label>
          <input
            type="number"
            class="form-input"
            [(ngModel)]="criteria.start_angle"
            min="0"
            max="360"
            placeholder="0"
          />
          <small class="form-hint">Starting angle in degrees (0-360)</small>
        </div>
      </div>

      <!-- Gauge Options -->
      <div *ngIf="isGaugeChart()" class="chart-specific-options">
        <div class="criteria-group">
          <label class="criteria-label">Min Value</label>
          <input
            type="number"
            class="form-input"
            [(ngModel)]="criteria.min_value"
          />
        </div>
        <div class="criteria-group">
          <label class="criteria-label">Max Value</label>
          <input
            type="number"
            class="form-input"
            [(ngModel)]="criteria.max_value"
          />
        </div>
        <!-- Thresholds would need a more complex UI - can be added later -->
      </div>

      <!-- Heatmap Options -->
      <div *ngIf="isHeatmapChart()" class="chart-specific-options">
        <div class="criteria-group">
          <label class="criteria-label">Color Scale</label>
          <select class="form-select" [(ngModel)]="criteria.color_scale">
            <option value="sequential">Sequential</option>
            <option value="diverging">Diverging</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Fallback criteria if API doesn't return any -->
    <div class="form-group form-section-card" *ngIf="criteriaOptions.length === 0 && selectedChartType">
      <label>Basic Criteria</label>
      <div class="criteria-group">
        <label class="criteria-label">Top N</label>
        <input
          type="text"
          class="form-input"
          [(ngModel)]="criteria.top_n"
          pattern="[1-9][0-9]*"
          title="Please enter a positive integer (1, 2, 3, ...)"
          data-field="top_n"
          (keypress)="onTopNKeyPress($event)"
          (input)="onTopNInput($event)"
        />
      </div>
      <div class="criteria-group">
        <label class="criteria-label">Time Bucket</label>
        <select class="form-select" [(ngModel)]="criteria.time_bucket">
          <option value="hour">Hour</option>
          <option value="day">Day</option>
          <option value="week">Week</option>
          <option value="month">Month</option>
        </select>
      </div>
      <div class="criteria-group">
        <label class="criteria-label">Sort Order</label>
        <select class="form-select" [(ngModel)]="criteria.sort_order">
          <option value="desc">Descending</option>
          <option value="asc">Ascending</option>
        </select>
      </div>
    </div>

      </div>
    </section>

  </div>

  <div class="form-actions">
    <button
      class="btn-save"
      [class.btn-save-loading]="isSavingChart"
      (click)="onSaveChart()"
      [disabled]="isLoading || !isFormValid()"
      [title]="!isFormValid() ? 'Please fill in all required fields' : 'Save chart'"
    >
      <span class="btn-save-spinner" *ngIf="isSavingChart"></span>
      <span *ngIf="!isSavingChart">Save Chart</span>
      <span *ngIf="isSavingChart" class="btn-save-text">{{ currentChartId ? 'Updating Chart...' : 'Generating Chart...' }}</span>
    </button>
    <button class="btn-cancel" (click)="onCancel()" [disabled]="isLoading">
      <span>Cancel</span>
    </button>
  </div>
</div>
